import { Title } from '@gerdau/hefesto/Title';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from '../../../../store';
import {
  ECustomerTypeView,
  EUserPreferenceType,
  ISaveUser,
  orderViewPreferenceDefault
} from '../../../../store/ducks/user/types';

import { Button } from '@gerdau/hefesto';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { useHistory, useLocation } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
import { INewLongSteelOrderData } from '../../../../store/ducks/new-long-steel-orders/types';
import { GetFlag } from '../../../../utils/featureFlag';
import { EFabricationRoutes } from '../../../Purchase/Fabrication/fabrication.routes';
import { EPurchaseRoutes } from '../../../Purchase/purchase.routes';
import OrdersFilters from '../OrdersFilters';
import { BlueFontRowActionContainer, Container } from './styles';
import { saveUser } from '../../../../store/ducks/user/actions';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

interface Props {
  isFiltered: boolean;
  onCleanFilters: () => void;
  onLoadOrders: ({
    states,
    customerIds,
    startDate,
    endDate
  }: {
    states: string[];
    customerIds: string[];
    startDate?: string;
    endDate?: string;
  }) => void;
  setFilteredOrders(filteredOrders: INewLongSteelOrderData[]): void;
  onEmittersChange?(emitterIds: string[]): void;
}

export const OrdersHeader = ({
  isFiltered,
  onCleanFilters,
  onLoadOrders,
  setFilteredOrders,
  onEmittersChange
}: Props) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );

  const user = useSelector((state: ApplicationState) => state.user);

  const dispatch = useDispatch();

  const getBreadcrumbs = () => {
    return [
      { name: 'Pedidos', url: ERoutes.ORDERS },
      {
        name: 'Pedidos de aços longos e planos',
        url: `${ERoutes.ORDERS}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
      },
      ...(pathname.includes(EFabricationRoutes.LAST_ORDERS)
        ? [
            {
              name: 'Histórico de pedidos',
              url: ''
            }
          ]
        : [])
    ];
  };

  const newLongSteelOrders = GetFlag('new_longsteelorders');

  const toggleExperience = () => {
    dispatch(
      sendTagging({
        event: 'click_abrir_experiencia_antiga',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        click_experiencia_antiga: '1',
        origem_experiencia: 'nova',
        destino_experiencia: 'antiga'
      })
    );

    const orderViewPreferences = user.preferences.find(
      (item) => item.name === EUserPreferenceType.ORDER_VIEW
    );

    const preferencesToggles =
      orderViewPreferences?.toggles || orderViewPreferenceDefault.toggles;

    const newToggles = preferencesToggles.map((item) => {
      if (item.value === 'newLongSteelOrdersView') {
        return {
          value: item.value,
          checked: !item.checked
        };
      }

      return item;
    });

    const newPreferences = {
      name: EUserPreferenceType.ORDER_VIEW,
      toggles: newToggles
    };

    const saveUserProps: ISaveUser = {
      user: user,
      userPreference: newPreferences
    };

    dispatch(saveUser(saveUserProps));
  };

  return (
    <Container>
      <Breadcrumbs
        breadcrumbItems={getBreadcrumbs()}
        onClick={(e) => {
          history.push(e);
        }}
      />

      <BlueFontRowActionContainer>
        <Title level={1}>Pedidos de aços longos e planos</Title>
        {newLongSteelOrders && (
          <Button
            variant="none"
            onClick={() => toggleExperience()}
            name={'toggleExperience'}
          >
            Abrir experiência antiga
          </Button>
        )}
      </BlueFontRowActionContainer>
      {customerViewType === ECustomerTypeView.EMITTER && (
        <span className="subtitle">
          Acompanhe o andamento dos seus pedidos efetuados de aços longos e
          planos.
        </span>
      )}

      {(customerViewType === ECustomerTypeView.RECEIVER ||
        customerViewType === ECustomerTypeView.FABRICATION_RECEIVER) && (
        <span className="subtitle">
          Selecione o recebedor do pedido para exibir os resultados.
        </span>
      )}

      <OrdersFilters
        key="order-filters"
        customerViewType={customerViewType}
        onCleanFilters={onCleanFilters}
        loadOrders={onLoadOrders}
        isFiltered={isFiltered}
        setFilteredOrders={setFilteredOrders}
        onEmittersChange={onEmittersChange}
      />
    </Container>
  );
};
